import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Swal from 'sweetalert2'

import Chip from '@material-ui/core/Chip'
import Tooltip from '@material-ui/core/Tooltip'
import { Grid } from '@material-ui/core'
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionActions from '@material-ui/core/AccordionActions'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import { setFilter, setFromLink } from '../../../redux/actions/select'
import { makeStyles } from '@material-ui/core/styles'
import Badge from '@material-ui/core/Badge'
import { defaultFilter } from '../../../utils'
import moment from 'moment'
import { cloneDeep } from 'lodash'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  blueBackground: {
    backgroundColor: '#5291fc'
  },
  greyBackground: {
    // backgroundColor: '#313438'
    backgroundColor: '#5a6268',
    '&.Mui-disabled': {
      backgroundColor: '#41494F !important'
    }
  },
  whiteText: {
    borderColor: '#FFFFFF',
    color: '#FFFFFF'
  },
  greenChip: {
    backgroundColor: '#97b557'
  },
  expandIcon: {
    color: '#FFFFFF'
  },
  accordianroot: {
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  accordionSummary: {
    display: 'block'
  },
  heading: {
    fontSize: '16px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  secondaryHeading: {
    color: '#FFFFFF'
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  details: {
    // alignItems: 'center'
    justifyContent: 'center'
  },
  column: {
    flexBasis: '33.33%'
  },
  accAction: {
    padding: 0
  }
}))

const Filters = (props) => {
  const classes = useStyles()
  const Filter = useSelector(state => state.selection.Filter)
  const { defaultReport = 'A' } = useSelector(state => state.auth)

  const dispatch = useDispatch()
  const [empty, setEmpty] = useState(true)
  const [renderItems, setRenderItems] = useState({ filters: [], dropdowns: [] })
  const [Default, setDefault] = useState(true)
  const [filterCount, setFilterCount] = useState(0)
  const { setSelectedStatus, fromLink } = { ...props }
  const deepDefaultFilter = cloneDeep(defaultFilter)

  const ConfirmResetToast = async (msg) => {
    const { value, dismiss } = await Swal.fire({
      title: msg.msg,
      text: msg.txt ? msg.txt : '',
      icon: 'question',
      showCancelButton: true,
      cancelButtonText: 'No',
      cancelButtonColor: '#97b557',
      confirmButtonText: 'Yes'
    })
    if (value) {
      return true
    } else if (dismiss) {
      return false
    }
  }

  const resetFilters = async (defaultOnlyBool) => {
    // if requesting reset of filters, check with the user beofre proceeding if the fromLink attribute is true
    const confirmReset = !fromLink ? true : await ConfirmResetToast({ msg: 'This action will return you to all Captures.', txt: 'Do you wish to continue?' })

    if (confirmReset) {
      // determine the desired status for the filter based on the user's preferred selection and if they have chosen to load it. Otherwise default to 'All'
      const newSelectedStatus = defaultOnlyBool && defaultReport ? defaultReport : 'A'
      // reset the entire filter with only the captureAreas conditionally overidden based on the users request to load their preferred status.
      const newFilter = { ...deepDefaultFilter, ...(defaultOnlyBool && { captureAreas: newSelectedStatus !== 'A' ? [newSelectedStatus] : [] }) }

      // if fromLink; reset it.
      if (fromLink) { dispatch(setFromLink(false)) }

      // set the filter
      dispatch(setFilter(newFilter))
      // set the status srop down
      setSelectedStatus(newSelectedStatus)

      // navigate to the correct page and capture list based on the current view
      const view = props.currentView || 'single'
      const captureQuery = view === 'list' ? 'activeCapture=0' : view === 'grid' ? 'activeCaptures=[]' : 'capture=1'
      props.history.push({
        pathname: '/captures',
        search: `?view=${view}${view !== 'single' ? '&page=1' : ''}&${captureQuery}`
      })
    }
  }

  const clickedClear = () => {
    setEmpty((prev) => !prev)
  }

  const removeFilter = useCallback((keyMap) => {
    const statusMap = {
      Problem: 'P',
      'Not A Problem': 'N',
      Unviewed: 'U',
      Hold: 'H',
      Resolved: 'S'
    }

    clickedClear()

    const clonedCurrentFilter = cloneDeep(Filter)
    // if we are removing any filters, be sure we reset the fastFilterID
    const filter = { ...clonedCurrentFilter, fastFilterID: '' }

    if (keyMap.key === 'phrase') {
      // If the value is a string, make it empty
      filter[keyMap.key] = ''
    } else if (keyMap.key === 'websiteUrl') {
      filter[keyMap.key] = ''
    } else if (keyMap.key === 'source') {
      // for source, reset it to all
      filter[keyMap.key] = 'all'
    } else if (keyMap.key === 'captureAreas' && Array.isArray(filter.captureAreas) && Boolean(statusMap[keyMap.filter])) {
      const { captureAreas: capAreas } = { ...filter }
      //   const captureAreas = filter.captureAreas.filter((capArea) => capArea !== 'P')
      //   filter.captureAreas = captureAreas
      // } else if (keyMap.key === 'captureAreas' && keyMap.filter === 'Not A Problem') {
      //   filter.captureAreas.splice(filter.captureAreas.indexOf('N'), 1)
      // } else if (keyMap.key === 'captureAreas' && keyMap.filter === 'Unviewed') {
      //   filter.captureAreas.splice(filter.captureAreas.indexOf('U'), 1)
      // } else if (keyMap.key === 'captureAreas' && keyMap.filter === 'Hold') {
      //   filter.captureAreas.splice(filter.captureAreas.indexOf('H'), 1)
      // } else if (keyMap.key === 'captureAreas' && keyMap.filter === 'Resolved') {
      //   filter.captureAreas.splice(filter.captureAreas.indexOf('S'), 1)
      const captureAreas = [...capAreas].filter((captureArea) => captureArea !== statusMap[keyMap.filter])
      filter.captureAreas = captureAreas
    } else if (keyMap.key === 'dateRange') {
      // for the date range reset the individual filter items
      filter.startDate = ''
      filter.endDate = ''
    } else if (keyMap.key === 'timeRange') {
      filter.starTime = ''
      filter.endTime = ''
    } else if (keyMap.key === 'sevRange') {
      filter.severityMin = 1
      filter.severityMax = 100
    } else if (keyMap.key === 'flagged') {
      filter.violationIDs = []

      if (
        (Array.isArray(filter.statusesToAdd) && Boolean(filter.statusesToAdd.length) && filter.statusesToAdd.indexOf('Flagged') >= 0) ||
        (Array.isArray(filter.captureAreas) && Boolean(filter.captureAreas.length) && filter.captureAreas.indexOf('Flagged') >= 0)
      ) {
        const { captureAreas, statusesToAdd } = { ...filter }
        const targetArr = captureAreas.indexOf('Flagged') >= 0 ? captureAreas : statusesToAdd

        if (captureAreas.indexOf('Flagged') >= 0) {
          filter.captureAreas = [...targetArr].filter((areaInfo) => areaInfo !== 'Flagged')
        } else {
          filter.statusesToAdd = [...targetArr].filter((areaInfo) => areaInfo !== 'Flagged')
        }
      }
    } else {
      // otherwise, it's an array and we need to get the index
      const targetArray = filter[keyMap.key]
      const index = targetArray.indexOf(keyMap.filter)
      targetArray.splice(index, 1)
    }
    // TODO determine whether cached violationIDs need to be preserved if user clears a filter
    filter.refresh = true
    filter.includeViolationIDs = []
    dispatch(setFilter(filter))

    if (filter.captureAreas.length === 0) {
      setSelectedStatus('A')
    } else if (filter.captureAreas.length === 1 && filter.captureAreas[0] === 'P') {
      setSelectedStatus('P')
    } else if (filter.captureAreas.length === 1 && filter.captureAreas[0] === 'U') {
      setSelectedStatus('U')
    } else if (filter.captureAreas.length === 1 && filter.captureAreas[0] === 'H') {
      setSelectedStatus('H')
    } else if (filter.captureAreas.length === 1 && filter.captureAreas[0] === 'S') {
      setSelectedStatus('S')
    } else if (filter.captureAreas.length === 1 && filter.captureAreas[0] === 'N') {
      setSelectedStatus('N')
    }

    if (props.currentView === 'list') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (props.currentView === 'grid') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
  }, [Filter, props, dispatch, setSelectedStatus])

  const setBadgeArray = useCallback((sourceArray, targetArray, title, key) => {
    // res.filters = setBadgeArray(usernames, res.filters, 'Username', 'usernames')
    if (Array.isArray(sourceArray) && Boolean(sourceArray.length)) {
      const newBadges = sourceArray.reduce((arr, filter) => {
        if (filter) {
          arr.push(
            <div className='filter-item mt-1' key={filter}>
              <Tooltip arrow title={`${title}: ${filter}`}>
                <Chip
                  label={`${title}: ${filter}`}
                  className='text-capitalize'
                  onClick={() => removeFilter({ key, filter })}
                  onDelete={() => removeFilter({ key, filter })}
                  color='primary'
                  classes={{ colorPrimary: classes.blueBackground }}
                  size='small'
                  style={{ maxWidth: 235 }}
                />
              </Tooltip>
            </div>
          )
        }
        return arr
      }, [])

      targetArray.push(newBadges)
    }

    return targetArray
  }, [classes, removeFilter])

  const renderFilters = useCallback(() => {
    const res = {
      filters: [],
      dropdowns: []
    }
    const {
      usernames, applications, workstations, categories, captureAreas, phrase, source,
      startTime, endTime, startDate, endDate, severityMin, severityMax, websiteUrl, statusesToAdd
    } = Filter

    const flaggedOnly = (() => {
      if (
        (Array.isArray(statusesToAdd) && Boolean(statusesToAdd.length)) ||
        (Array.isArray(captureAreas) && Boolean(captureAreas.length))
      ) {
        const flagStatus = Boolean(statusesToAdd.length) && Boolean(statusesToAdd.find(
          (filterInfo) => typeof filterInfo === 'string' && (/Flagged/ig).test(filterInfo)
        ))

        const flagCapture = Boolean(captureAreas.length) && Boolean(captureAreas.find(
          (filterInfo) => typeof filterInfo === 'string' && (/Flagged/ig).test(filterInfo)
        ))

        return (flagStatus || flagCapture)
      }

      return false
    })()

    const isCaptureArea = flaggedOnly && Boolean(captureAreas.find((filterInfo) => typeof filterInfo === 'string' && (/Flagged/ig).test(filterInfo)))

    let totalLength = usernames.length + applications.length + workstations.length + categories.length + (captureAreas.length - Number(isCaptureArea))
    if (flaggedOnly) { totalLength += 1 }
    if (startTime && endTime) { totalLength += 1 }
    // JJC only count endDate as a filter if it represents a time greater than the past 10 minutes
    if (startDate || (endDate && moment().diff(moment(endDate)) > 600000)) { totalLength += 1 }
    if ((severityMin > 1 && severityMax <= 100) || (severityMin >= 1 && severityMax < 100)) { totalLength += 1 }
    if (source !== 'all') { totalLength += 1 }
    if (phrase) { totalLength += 1 }
    if (websiteUrl) { totalLength += 1 }
    if (totalLength !== 0) {
      setDefault(false)
    } else {
      setDefault(true)
    }

    setFilterCount(totalLength)

    if (phrase.length) { res.filters = setBadgeArray([phrase], res.filters, 'Phrase', 'phrase') }
    if (websiteUrl.length) { res.filters = setBadgeArray([websiteUrl], res.filters, 'Website', 'websiteUrl') }
    if (startTime && startTime > 0 && endTime && endTime > 0) {
      const startM = moment(startTime)
      const endM = moment(endTime)
      const start = startM.format('h:mm A')
      const end = endM.format('h:mm A')
      const timeRange = `${start} - ${end}`
      setBadgeArray([timeRange], res.filters, 'Time Range', 'timeRange')
    }
    if (startDate && startDate > 0 && endDate && endDate > 0) {
      const startx = moment(startDate)
      const endx = moment(endDate)
      const start = startx.format('LL')
      const end = endx.format('LL')
      const timeRange = `${start} - ${end}`
      setBadgeArray([timeRange], res.filters, 'Date Range', 'dateRange')
    }
    if (startDate && startDate > 0 && (!endDate || endDate === 0)) {
      const startx = moment(startDate)
      // need more granular time info if only one date filter
      const start = startx.format('MMMM Do YYYY, h:mm a')
      const timeRange = `${start}`
      setBadgeArray([timeRange], res.filters, 'Date', 'dateRange')
    }
    // JJC add date display for end date only filter if greater than 10 minutes in the past
    if (endDate && endDate > 0 && (!startDate || startDate === 0)) {
      const endx = moment(endDate)
      const diffx = moment().diff(endx)
      if (diffx && diffx > 600000) {
        const end = endx.format('MMMM Do YYYY, h:mm a')
        const timeRange = `${end}`
        setBadgeArray([timeRange], res.filters, 'Date', 'dateRange')
      }
    }
    if ((severityMin > 1 && severityMax <= 100) || (severityMin >= 1 && severityMax < 100)) {
      const sevRange = `${severityMin} - ${severityMax}`
      setBadgeArray([sevRange], res.filters, 'Severity', 'sevRange')
    }
    if (source !== 'all') {
      if (source === 0) { setBadgeArray(['keyboard'], res.filters, 'Source', 'source') }
      if (source === 1) { setBadgeArray(['application'], res.filters, 'Source', 'source') }
    }
    if (captureAreas.length) {
      const translatedCaptures = []
      captureAreas.forEach((item) => {
        switch (item) {
          case 'Sh':
            return translatedCaptures.push('Shared')
          case 'N':
            return translatedCaptures.push('Not A Problem')
          case 'P':
            return translatedCaptures.push('Problem')
          case 'H':
            return translatedCaptures.push('Hold')
          case 'S':
            return translatedCaptures.push('Resolved')
          case 'U':
            return translatedCaptures.push('Unviewed')
          default:
            return ''
        }
      })
      res.filters = setBadgeArray(translatedCaptures, res.filters, 'Status', 'captureAreas')
    }

    if (flaggedOnly) { res.filters = setBadgeArray(['Flagged'], res.filters, 'Status', 'flagged') }
    res.filters = setBadgeArray(usernames, res.filters, 'Username', 'usernames')
    res.filters = setBadgeArray(applications, res.filters, 'Application', 'applications')
    res.filters = setBadgeArray(workstations, res.filters, 'Workstation', 'workstations')
    res.filters = setBadgeArray(categories, res.filters, 'Category', 'categories')

    return res
  }, [Filter, setBadgeArray])

  useEffect(() => {
    setRenderItems(renderFilters())
  }, [renderFilters])

  return (
    <div className={`${classes.accordianroot}`}>
      <Badge
        badgeContent={
          <Typography className='font-weight-bold'>{filterCount}</Typography>
        }
        color='primary'
        max={10}
        invisible={filterCount === 0}
        classes={{ colorPrimary: classes.greenChip }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <Accordion classes={{ root: classes.greyBackground }} disabled={Default} expanded={!empty && filterCount > 0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
            aria-controls='panel1c-content'
            id='panel1c-header'
            onClick={clickedClear}
            classes={{ content: classes.accordionSummary }}
          >
            <div className={classes.column}>
              <Typography className={classes.heading}>Filters: &nbsp; &nbsp;</Typography>
              {!Default &&
                <Typography variant='caption' className={classes.secondaryHeading} style={{ textTransform: 'none' }}>Click here to see applied filters.</Typography>}
            </div>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <div className={classes.column}>
              {renderItems.filters}
            </div>
          </AccordionDetails>
          <Divider />
          <AccordionActions hidden={filterCount === 0} className={classes.accAction}>
            <Grid container item direction='row' justify='space-between'>
              <Button size='small' className='font-weight-bold' style={{ color: '#FFFFFF' }} onClick={() => { clickedClear(); resetFilters(true) }}>Load Default Status</Button>
              <Button size='small' className='font-weight-bold' style={{ color: '#FFFFFF' }} onClick={() => { clickedClear(); resetFilters(false) }}>Clear All</Button>
            </Grid>
          </AccordionActions>
        </Accordion>
      </Badge>
    </div>
  )
}

export default withRouter(Filters)
